import React, { memo, useMemo } from "react";
import { PatientConnectionTypeCodes, PatientConnectionTypeCodes_Descriptions } from "csd.phoenix.models/PatientConnectionTypeCodes";
import { useFormikContext, getIn } from "formik";
import { getEnumValues } from "../../../../../../utils/objectUtils";
import { IFieldOption, IPatientConnectionTypeFieldProps } from "../../../models";
import SelectField from "../../SelectField";
import useFormContext from "../../../FormContext";
import usePromiseState from "../../../../usePromiseState";


// const list: IFieldOption[] = [
//   {"value": 16, "text": "Spouse"},
//   {"value": 2, "text": "Parent"},
//   {"value": 17, "text": "Child"},
//   {"value": 4, "text": "Guardian"},
//   {"value": 0, "text": "Other" },
//   {"value": 1, "text": "Self" }
// ];

const getSpanishList = (): Promise<IFieldOption[]> => {
  return import(/* webpackChunkName: "patientconnections-spanish" */ "./SpanishPatientConnections.json").then(m => m.default);
}

const handleSelfSelection = (currentValue: any, options: IFieldOption[], excludeSelfSelection: boolean) => {

  const selfDescription = options.find(v => v.value === PatientConnectionTypeCodes.Self)?.text
    ?? PatientConnectionTypeCodes_Descriptions[currentValue];

  options = (excludeSelfSelection && options.filter(v => v.value !== PatientConnectionTypeCodes.Self)) || options;

  if (!options.some(p => p.value === currentValue) && (currentValue !== undefined)) {
    options.push({ text: selfDescription, value: currentValue });
  }

  return options;

}

const getFieldList = (currentValue: any, excludeSelfSelection: boolean): IFieldOption[] => {

  let options = getEnumValues(PatientConnectionTypeCodes)
    .filter(v => v !== PatientConnectionTypeCodes.Unknown)
    .map((value) => ({
      value,
      text: PatientConnectionTypeCodes_Descriptions[value]
    }));

  return handleSelfSelection(currentValue, options, excludeSelfSelection);

}

const updateSpanishList = (options: IFieldOption[], currentValue: any, excludeSelfSelection: boolean): IFieldOption[] => {

  (currentValue !== PatientConnectionTypeCodes.Unknown) &&
    (options = options.filter(v => v.value !== PatientConnectionTypeCodes.Unknown));

  return handleSelfSelection(currentValue, options, excludeSelfSelection);
}


const PatientConnectionTypeField: React.FC<IPatientConnectionTypeFieldProps> = memo((props) => {
  const { values } = useFormikContext();
  const { isPrinting, locale, } = useFormContext();
  const isSpanish = locale === "es-US";
  const promise = useMemo(() => isPrinting || !isSpanish ? Promise.resolve([]) : getSpanishList(), [isPrinting, isSpanish]);
  const currentValue = getIn(values, props.binding);
  const excludeSelfSelection = props.excludeSelfSelection ?? false;
  const [isLoading, result] = usePromiseState(promise);
  const options = useMemo(() => isSpanish ? updateSpanishList(result || [], currentValue, excludeSelfSelection) :
    getFieldList(currentValue, excludeSelfSelection), [currentValue, excludeSelfSelection, isSpanish, result]);

  if (isSpanish)
    return <SelectField {...props} options={options || []} isLoading={isLoading} />
  else
    return <SelectField {...props} options={options} />
})


export default PatientConnectionTypeField;
